class UseEnv {
  private readonly BASE_URL;
  private readonly SOCKET_URL;

  constructor() {
    if (import.meta.env.DEV) {
      this.BASE_URL = `//${window.location.host}`;
      this.SOCKET_URL = "ws://61.146.45.234:3302/api/connectWebSocket";
    } else {
      this.BASE_URL = `//${window.location.host}`;
      this.SOCKET_URL = `ws://${window.location.host}/connectWebSocket`;
    }
  }
  setLocalUrl(value: string) {
    window.localStorage.setItem("local_url", value);
  }
  getLocalUrl() {
    return window.localStorage.getItem("local_url");
  }
  get baseUrl() {
    return this.BASE_URL;
  }
  get socketUrl() {
    return this.SOCKET_URL;
  }
}
export const useEnv = function () {
  return new UseEnv();
};
